module.exports = __webpack_public_path__ + "img/7.5198c1e3.png";